export default __webpack_public_path__ + "static/media/waterlevelsensor.452f143f.jpg";